import { render, staticRenderFns } from "./product-foldout.vue?vue&type=template&id=6df3d3e2&"
import script from "./product-foldout.vue?vue&type=script&lang=js&"
export * from "./product-foldout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports